import React, { useMemo } from "react";
import { ArrowDownOutlined, ArrowUpOutlined } from "@ant-design/icons";
import { Badge, Card, Descriptions, Empty, Tabs } from "antd";
import { connect } from "dva";
import moment from "moment";
import { SECURE_PASS_TAG_STATUS } from "@/utils/enum";
import { formatPhoneNumber, getRestrictedDaysOfWeekAsString } from "@/utils/utils";
import ETAWindow from "@/components/ETAWindow";
import SecurePassAlert from "@/components/SecurePass/SecurePassAlert/SecurePassAlert";
import SecurePassText from "@/components/SecurePass/SecurePassText/SecurePassText";

const { TabPane } = Tabs;

const TripCard = ({ tripTime, data, securePassEnabled, shipmentDetails }) => {
  const shipmentData = useMemo(() => shipmentDetails.data, [shipmentDetails]);

  return (
    <Card className="tripCard" style={{ minHeight: "100%" }} bodyStyle={{ padding: 0, paddingBottom: 24 }}>
      <Tabs defaultActiveKey="1" className="dealerShipmentCardTabs">
        <TabPane
          key="1"
          tab={
            <span style={{ padding: 12 }}>
              <span
                style={{
                  padding: 5,
                  background: `${tripTime === "Pickup" ? "rgba(0, 0, 0, 0.85)" : "#2d6ac4"}`,
                  marginRight: 12,
                  borderRadius: 5,
                }}
              >
                {tripTime === "Pickup" ? (
                  <ArrowUpOutlined style={{ margin: 0, color: "white" }} />
                ) : (
                  <ArrowDownOutlined style={{ margin: 0, color: "white" }} />
                )}
              </span>
              {tripTime} Information
            </span>
          }
        >
          <Descriptions bordered column={1}>
            <Descriptions.Item label="Location Name">{data?.name}</Descriptions.Item>
            <Descriptions.Item label="Address">{data.completedAddress}</Descriptions.Item>
            {data.actual ? (
              <Descriptions.Item label="Actual">
                {moment.utc(data.actual).local().locale("en").format("MM/DD/YY, h:mm A")}
              </Descriptions.Item>
            ) : (
              <Descriptions.Item label="ETA">
                <ETAWindow etaDate={data.eta} etaTimeSlotIndex={data.etaTimeSlot} />
              </Descriptions.Item>
            )}

            <Descriptions.Item label="Contact Name">{data.contactName}</Descriptions.Item>
            <Descriptions.Item label="Contact Phone">
              {formatPhoneNumber(data.contactPhone, data.contactPhoneExtension)}
            </Descriptions.Item>
            <Descriptions.Item label="Day(s) of Week Unavailable">
              {getRestrictedDaysOfWeekAsString(data?.dayOfWeekRestricted?.split(","))}
            </Descriptions.Item>
          </Descriptions>
        </TabPane>
        <TabPane
          tab={
            <span>
              {tripTime} Notes
              <Badge
                count={data.notes ? 1 : 0}
                showZero
                style={{
                  marginLeft: 5,
                  backgroundColor: data.notes ? "red" : "#d9d9d9",
                }}
              />
            </span>
          }
          key="2"
        >
          {data.notes ? (
            <Descriptions bordered column={1}>
              <Descriptions.Item label="Instructions" key="pickupInstructions">
                {data.notes}
              </Descriptions.Item>
            </Descriptions>
          ) : (
            <Empty style={{ paddingTop: 6 }} image={Empty.PRESENTED_IMAGE_SIMPLE} />
          )}
        </TabPane>
        {securePassEnabled && tripTime === "Pickup" && (
          <TabPane
            tab={
              <span>
                <SecurePassText />
                <Badge
                  count={shipmentData?.securePass === SECURE_PASS_TAG_STATUS.Enabled ? 1 : 0}
                  showZero
                  style={{
                    marginLeft: 5,
                    backgroundColor: shipmentData?.securePass === SECURE_PASS_TAG_STATUS.Enabled ? "red" : "#d9d9d9",
                  }}
                />
              </span>
            }
            key="3"
          >
            <SecurePassAlert
              securePassValue={shipmentData?.securePass}
              contactEmail={data.contactEmail}
              shipmentStatus={shipmentData?.status}
              loadStatus={shipmentData?.load?.status}
            />
          </TabPane>
        )}
      </Tabs>
    </Card>
  );
};

export default connect(({ configs, shipmentDetails }) => ({
  securePassEnabled: configs.securePass.enabled,
  shipmentDetails,
}))(TripCard);
